(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const findRealButton = (scope) =>
      scope.querySelector('[data-testid="standalone-add-to-cart"]') ||
      scope.querySelector('.buy-buttons-block .add-to-cart-button') ||
      scope.querySelector('.buy-buttons-block button[name="add"]') ||
      scope.querySelector('.product-details button[name="add"]') ||
      scope.querySelector('.product-details button[type="submit"]');

    const initStickyAtc = (root, attempt = 0) => {
      if (root.dataset.gmInit === 'true') return;
      const scope = root.closest('.shopify-section') || document;
      const realButton = findRealButton(scope);
      const bar = root.querySelector('.gm-sticky-atc__bar');
      const cloneButton = root.querySelector('[data-gm-sticky-button]');

      if (!realButton || !bar || !cloneButton) {
        if (attempt < 15) {
          setTimeout(() => initStickyAtc(root, attempt + 1), 200);
        } else {
          console.warn(
            '[gm-sticky-atc] Bouton "Ajouter au panier" introuvable — la barre flottante reste inactive. La classe réelle du bouton dans ce thème ne correspond à aucun des sélecteurs essayés.'
          );
        }
        return;
      }
      root.dataset.gmInit = 'true';

      const priceSource = scope.querySelector('.product-details .price');
      const priceTargets = root.querySelectorAll('[data-gm-sticky-price]');
      const header = document.getElementById('header-component');
      const desktopQuery = window.matchMedia('(min-width: 750px)');
      let state = '';
      let frame = null;
      let isMobileActive = false;

      const label = cloneButton.querySelector('.gm-sticky-atc__label');
      const realIcon = realButton.querySelector('svg, .svg-wrapper, [class*="icon"]');
      if (realIcon && label) {
        const iconClone = realIcon.cloneNode(true);
        iconClone.classList.add('gm-sticky-atc__icon');
        label.parentNode.insertBefore(iconClone, label);
      }

      cloneButton.addEventListener('click', () => realButton.click());

      // Quantity/volume-discount apps (e.g. the "Quantité" offer picker) manage their own price
      // display outside the theme's normal .price element, and may render after this script's
      // first run — so the container is looked up fresh every time rather than cached once.
      // Some of these apps also don't use the native radio "checked" state at all (their inputs
      // are marked readonly and selection is only reflected via an inline background-color
      // change) — so both signals are checked, not just :checked.
      const isDarkBackground = (el) => {
        const bg = el && el.style && el.style.backgroundColor;
        const match = bg && bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (!match) return false;
        const [, r, g, b] = match.map(Number);
        return r < 80 && g < 80 && b < 80;
      };

      const getSelectedOfferPriceInfo = () => {
        const offersContainer = scope.querySelector('[data-cart-button-id], [id^="offers-list-container"]');
        if (!offersContainer) return null;
        const radios = Array.from(offersContainer.querySelectorAll('input[name="offer"]'));
        if (radios.length === 0) return null;
        const checkedOffer = radios.find((r) => r.checked) || radios.find(isDarkBackground);
        if (!checkedOffer) return null;
        let row = checkedOffer.parentElement;
        for (let i = 0; i < 6 && row; i++) {
          const moneyEls = row.querySelectorAll('.money');
          if (moneyEls.length > 0) {
            return {
              price: moneyEls[0].textContent.replace(/\s+/g, ' ').trim(),
              comparePrice: moneyEls.length > 1 ? moneyEls[1].textContent.replace(/\s+/g, ' ').trim() : '',
            };
          }
          row = row.parentElement;
        }
        return null;
      };

      const compareTargets = root.querySelectorAll('[data-gm-sticky-compare-price]');

      // The main product price (top of the page, inside <product-price>) doesn't belong to
      // this floating bar, but it has the same "stuck on the base variant price" problem: it
      // never reflected whichever PandaBundle offer the customer had selected. Its currency
      // symbol/spacing is captured once from its own initial text (e.g. "€45,80") so the
      // rewritten value matches the theme's own formatting instead of PandaBundle's
      // ("45,80 €") when an offer is applied.
      const mainPriceCurrencySymbol = priceSource
        ? priceSource.textContent.replace(/[\d.,\s ]/g, '').trim() || '€'
        : '€';
      let lastMainPriceWrite = '';

      const sync = () => {
        const offerInfo = getSelectedOfferPriceInfo();
        const text = offerInfo ? offerInfo.price : priceSource ? priceSource.textContent.replace(/\s+/g, ' ').trim() : '';
        if (text) priceTargets.forEach((el) => (el.textContent = text));
        const compareText = offerInfo ? offerInfo.comparePrice : '';
        compareTargets.forEach((el) => {
          if (compareText) {
            el.textContent = compareText;
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        cloneButton.disabled = realButton.disabled || realButton.hasAttribute('disabled');

        if (priceSource && offerInfo) {
          const amount = offerInfo.price.replace(/[^\d.,]/g, '');
          const newMainText = `${mainPriceCurrencySymbol}${amount}`;
          if (amount && priceSource.textContent.trim() !== newMainText && newMainText !== lastMainPriceWrite) {
            lastMainPriceWrite = newMainText;
            priceSource.textContent = newMainText;
          }
        }
      };

      // Mirror the real button's own "Ajouté" confirmation onto the clone: the real one may be
      // scrolled out of view (hidden behind the floating bar) when the customer actually clicks,
      // so its own confirmation would go unseen otherwise.
      const addedTarget = scope.querySelector('.add-to-cart-text--added, [class*="-added"]');
      if (addedTarget) {
        const isRealAddedVisible = () => addedTarget.offsetParent !== null;
        let wasVisible = isRealAddedVisible();
        const addedObserver = new MutationObserver(() => {
          const nowVisible = isRealAddedVisible();
          if (nowVisible !== wasVisible) {
            wasVisible = nowVisible;
            root.classList.toggle('is-added', nowVisible);
          }
        });
        addedObserver.observe(scope, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden'] });
      }

      const setState = (next) => {
        if (state === next) return;
        state = next;
        root.dataset.state = next;
      };

      const sectionEl = scope === document ? document.body : scope;

      // Floating side inset on mobile: theme page margin (px or rem) + a slight extra.
      // Cached and only recomputed on resize — depends on a CSS custom property that
      // never changes mid-scroll, so recalculating it every animation frame (via
      // getComputedStyle, itself a forced style recalculation) was pure waste and
      // one of the main causes of stutter on fast scroll.
      const getFloatInset = () => {
        const raw = getComputedStyle(document.documentElement).getPropertyValue('--page-margin').trim();
        const n = parseFloat(raw);
        if (!raw || isNaN(n)) return 22;
        if (raw.endsWith('rem')) {
          return n * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16) + 6;
        }
        return n + 6;
      };
      let cachedFloatInset = getFloatInset();

      const lerp = (a, b, t) => a + (b - a) * t;
      const clamp01 = (v) => Math.max(0, Math.min(1, v));

      const update = () => {
        frame = null;
        const rect = realButton.getBoundingClientRect();
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;

        if (desktopQuery.matches) {
          // Desktop: no morphing — the theme's own CSS transition handles the show/hide
          // slide (see .gm-sticky-atc__bar in the stylesheet), so nothing to write here
          // beyond the state flag, and only when actually switching away from mobile.
          if (isMobileActive) {
            isMobileActive = false;
            sectionEl.classList.remove('gm-clone-active');
            root.style.transform = '';
            root.style.width = '';
            root.style.height = '';
          }
          setState(rect.bottom < headerBottom ? 'desktop-visible' : 'desktop-hidden');
          return;
        }

        // Mobile geometry.
        const rectHeight = rect.height || 48;
        const topGap = 12;
        const topPin = headerBottom + topGap;
        const bottomPin = window.innerHeight - rectHeight - 20;
        const zone = 96;

        if (rect.top <= bottomPin && rect.bottom >= topPin + rectHeight) {
          if (isMobileActive) {
            isMobileActive = false;
            sectionEl.classList.remove('gm-clone-active');
            root.style.transform = '';
            root.style.width = '';
            root.style.height = '';
          }
          setState('docked');
          return;
        }

        if (!isMobileActive) {
          isMobileActive = true;
          sectionEl.classList.add('gm-clone-active');
        }

        const floatLeft = cachedFloatInset;
        const floatWidth = Math.max(0, window.innerWidth - cachedFloatInset * 2);

        let next;
        let top;
        let t; // 0 = fully floating metrics, 1 = exactly the real button's metrics

        if (rect.top > bottomPin) {
          next = 'bottom';
          top = bottomPin;
          t = clamp01(1 - (rect.top - bottomPin) / zone);
        } else {
          next = 'top';
          top = topPin;
          t = clamp01(1 - (topPin + rectHeight - rect.bottom) / zone);
        }

        setState(next);
        const left = Math.round(lerp(floatLeft, rect.left, t));
        const width = Math.round(lerp(floatWidth, rect.width, t));
        root.style.transform = `translate3d(${left}px, ${Math.round(top)}px, 0)`;
        root.style.width = `${width}px`;
        root.style.height = `${Math.round(rectHeight)}px`;
      };

      const requestUpdate = () => {
        if (frame === null) frame = requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', () => {
        cachedFloatInset = getFloatInset();
        requestUpdate();
      });
      desktopQuery.addEventListener('change', requestUpdate);

      const observer = new MutationObserver(() => {
        sync();
        requestUpdate();
      });
      if (priceSource) {
        observer.observe(priceSource, { childList: true, subtree: true, characterData: true });
      }
      observer.observe(realButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      observer.observe(scope, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });

      document.addEventListener('click', (e) => {
        if (e.target.closest && e.target.closest('[name="offer"], [data-cart-button-id], [id^="offers-list-container"]')) {
          setTimeout(sync, 60);
        }
      });

      setInterval(sync, 1000);

      sync();
      update();
      root.classList.add('is-ready');
    };

    const normalizeHeading = (str) =>
      str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

    /* {% javascript %} blocks compile to a static shared asset — Liquid tags don't
       run in here. Translated strings are set on window.GM_I18N by a small inline
       <script> in this section's HTML (see below), which does get Liquid-processed. */
    const GM_I18N = window.GM_I18N || {
      description: 'Description',
      shipping: 'Livraison et retours',
      guarantee: 'Garantie anti-casse',
      showMore: 'Voir plus',
      showLess: 'Voir moins',
      cocktailKit: 'Contenu du kit cocktail',
      specs: 'Caractéristiques techniques',
    };

    const RECOGNIZED_HEADINGS = [
      {
        key: 'cocktailKit',
        match: [
          'contenu du kit cocktail',
          "contenu de l'ensemble a cocktail",
          'cocktail kit contents',
          "what's in the cocktail kit",
          'contenido del kit de coctel',
          'contenuto del kit cocktail',
          'inhalt des cocktail-kits',
        ],
        label: GM_I18N.cocktailKit,
      },
      {
        key: 'specs',
        match: [
          'caracteristiques techniques',
          'technical specifications',
          'especificaciones tecnicas',
          'caracteristicas tecnicas',
          'caratteristiche tecniche',
          'technische daten',
          'technische eigenschaften',
        ],
        label: GM_I18N.specs,
      },
    ];

    const COLLAPSIBLE_HEADINGS = [
      'ideal pour',
      'pourquoi',
      'ideal for',
      'perfect for',
      'why',
      'ideal para',
      'para quien es ideal',
      'por que',
      'ideale per',
      'ideal per',
      'perche',
      'geeignet fur',
      'warum',
    ];

    const initDescTabs = (root) => {
      if (root.dataset.gmInit === 'true') return;
      const source = root.querySelector('[data-gm-desc-source]');
      if (!source) {
        console.warn('[gm-desc-tabs] Conteneur source (data-gm-desc-source) introuvable dans le bloc description.');
        return;
      }
      root.dataset.gmInit = 'true';

      const scope = root.closest('.shopify-section') || document;

      const buyButtonsBlock = scope.querySelector('.buy-buttons-block');
      if (buyButtonsBlock) {
        buyButtonsBlock.insertAdjacentElement('afterend', root);
      } else {
        console.warn('[gm-desc-tabs] Bloc "Ajouter au panier" introuvable — les onglets restent sous la galerie.');
      }

      const buckets = { description: document.createElement('div') };
      let current = buckets.description;
      let sawAnyNode = false;

      Array.from(source.childNodes).forEach((node) => {
        const isHeading = node.nodeType === 1 && /^H[23]$/.test(node.tagName);
        if (isHeading) {
          const rawTitle = node.textContent.trim();
          const norm = normalizeHeading(rawTitle);
          const recognized = RECOGNIZED_HEADINGS.find((h) => h.match.some((m) => norm === m || norm.startsWith(m)));
          if (recognized && rawTitle) {
            if (!buckets[recognized.key]) buckets[recognized.key] = document.createElement('div');
            current = buckets[recognized.key];
            sawAnyNode = true;
            return;
          }
          const isCollapsible = COLLAPSIBLE_HEADINGS.some((h) => norm === h || norm.startsWith(h));
          if (isCollapsible) {
            if (!buckets.collapsible) buckets.collapsible = document.createElement('div');
            current = buckets.collapsible;
            current.appendChild(node.cloneNode(true));
            sawAnyNode = true;
            return;
          }
          current = buckets.description;
          const headingClone = node.cloneNode(true);
          if (!sawAnyNode) {
            headingClone.classList.add('gm-visually-hidden');
          }
          current.appendChild(headingClone);
          sawAnyNode = true;
          return;
        }
        const isEmptyText = node.nodeType === 3 && !node.textContent.trim();
        if (isEmptyText) return;
        current.appendChild(node.cloneNode(true));
        sawAnyNode = true;
      });

      if (buckets.collapsible) {
        const moreToggle = document.createElement('button');
        moreToggle.type = 'button';
        moreToggle.className = 'gm-desc-tabs__more-toggle';
        moreToggle.textContent = GM_I18N.showMore;
        const moreContent = document.createElement('div');
        moreContent.className = 'gm-desc-tabs__more-content';
        moreContent.hidden = true;
        moreContent.appendChild(buckets.collapsible);
        buckets.description.appendChild(moreToggle);
        buckets.description.appendChild(moreContent);
      }

      const sections = [{ title: GM_I18N.description, content: buckets.description, fixed: true }];
      RECOGNIZED_HEADINGS.forEach((h) => {
        if (buckets[h.key]) {
          sections.push({ title: h.label, content: buckets[h.key] });
        }
      });

      const shippingSource = root.querySelector('[data-gm-desc-shipping]');
      if (shippingSource) {
        const shippingContent = document.createElement('div');
        Array.from(shippingSource.childNodes).forEach((n) => shippingContent.appendChild(n.cloneNode(true)));
        sections.push({ title: GM_I18N.shipping, content: shippingContent, fixed: true });
      }

      const guaranteeSource = root.querySelector('[data-gm-desc-guarantee]');
      if (guaranteeSource) {
        const guaranteeContent = document.createElement('div');
        Array.from(guaranteeSource.childNodes).forEach((n) => guaranteeContent.appendChild(n.cloneNode(true)));
        sections.push({ title: GM_I18N.guarantee, content: guaranteeContent, fixed: true });
      }

      const cleanSections = sections.filter(
        (s) => s.fixed || s.content.textContent.trim() !== '' || s.content.querySelector('img, video, iframe')
      );

      console.log('[gm-desc-tabs] sections detectees:', cleanSections.map((s) => s.title));

      if (cleanSections.length === 0) {
        console.warn('[gm-desc-tabs] Aucune section detectee — rien affiche.');
        return;
      }

      const wireMoreToggle = (container) => {
        const toggle = container.querySelector('.gm-desc-tabs__more-toggle');
        const content = container.querySelector('.gm-desc-tabs__more-content');
        if (!toggle || !content) return;
        toggle.addEventListener('click', () => {
          const willShow = content.hidden;
          content.hidden = !willShow;
          toggle.textContent = willShow ? GM_I18N.showLess : GM_I18N.showMore;
        });
      };

      const uid = root.dataset.gmId || 'desc';
      const tabsWrap = document.createElement('div');
      tabsWrap.className = 'gm-desc-tabs__desktop';
      const tabList = document.createElement('div');
      tabList.className = 'gm-desc-tabs__list';
      tabList.setAttribute('role', 'tablist');
      const indicator = document.createElement('span');
      indicator.className = 'gm-desc-tabs__indicator';
      const divider = document.createElement('hr');
      divider.className = 'gm-desc-tabs__divider';
      const panelsWrap = document.createElement('div');
      panelsWrap.className = 'gm-desc-tabs__panels';

      const accWrap = document.createElement('div');
      accWrap.className = 'gm-desc-tabs__mobile';

      const moveIndicator = (tabBtn) => {
        indicator.style.left = `${tabBtn.offsetLeft}px`;
        indicator.style.width = `${tabBtn.offsetWidth}px`;
      };

      const FADE_MS = 150;

      const switchToPanel = (tabBtn, panel) => {
        const currentTab = tabList.querySelector('.gm-desc-tabs__tab.is-active');
        const currentPanel = panelsWrap.querySelector('.gm-desc-tabs__panel:not([hidden])');
        if (currentTab === tabBtn) return;

        tabList.querySelectorAll('.gm-desc-tabs__tab').forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        tabBtn.classList.add('is-active');
        tabBtn.setAttribute('aria-selected', 'true');
        moveIndicator(tabBtn);

        if (currentPanel && currentPanel !== panel) {
          currentPanel.style.opacity = '0';
          setTimeout(() => {
            currentPanel.hidden = true;
            panel.hidden = false;
            panel.style.opacity = '0';
            requestAnimationFrame(() => {
              panel.style.opacity = '1';
            });
          }, FADE_MS);
        } else {
          panel.hidden = false;
          panel.style.opacity = '1';
        }
      };

      cleanSections.forEach((sectionData, index) => {
        const tabId = `gm-desc-tab-${uid}-${index}`;
        const panelId = `gm-desc-panel-${uid}-${index}`;

        const tabBtn = document.createElement('button');
        tabBtn.type = 'button';
        tabBtn.id = tabId;
        tabBtn.className = 'gm-desc-tabs__tab';
        tabBtn.textContent = sectionData.title;
        tabBtn.setAttribute('role', 'tab');
        tabBtn.setAttribute('aria-controls', panelId);
        tabBtn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        if (index === 0) tabBtn.classList.add('is-active');

        const panel = document.createElement('div');
        panel.id = panelId;
        panel.className = 'gm-desc-tabs__panel details-content';
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.appendChild(sectionData.content.cloneNode(true));
        wireMoreToggle(panel);
        if (index !== 0) panel.hidden = true;

        tabBtn.addEventListener('click', () => switchToPanel(tabBtn, panel));

        tabList.appendChild(tabBtn);
        panelsWrap.appendChild(panel);

        const accordionCustom = document.createElement('accordion-custom');
        const details = document.createElement('details');
        details.className = 'details';
        details.setAttribute('data-testid', 'accordion-details');
        const summary = document.createElement('summary');
        summary.className = 'details__header';
        summary.appendChild(document.createTextNode(sectionData.title));
        summary.insertAdjacentHTML(
          'beforeend',
          '<span class="svg-wrapper icon-plus"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path><path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path></svg></span>'
        );
        const accContent = document.createElement('div');
        accContent.className = 'details-content';
        accContent.appendChild(sectionData.content.cloneNode(true));
        wireMoreToggle(accContent);
        details.appendChild(summary);
        details.appendChild(accContent);
        accordionCustom.appendChild(details);
        accWrap.appendChild(accordionCustom);
      });

      tabList.appendChild(indicator);
      tabsWrap.appendChild(tabList);
      tabsWrap.appendChild(divider);
      tabsWrap.appendChild(panelsWrap);
      root.appendChild(tabsWrap);
      root.appendChild(accWrap);
      root.classList.add('is-parsed');

      const firstTab = tabList.querySelector('.gm-desc-tabs__tab.is-active');
      if (firstTab) requestAnimationFrame(() => moveIndicator(firstTab));
      window.addEventListener('resize', () => {
        const activeTab = tabList.querySelector('.gm-desc-tabs__tab.is-active');
        if (activeTab) moveIndicator(activeTab);
      });

      console.log('[gm-desc-tabs] onglets/accordeon construits:', cleanSections.length, 'sections');
    };

    const initMaterialBadges = (root, attempt = 0) => {
      if (root.dataset.gmInit === 'true') return;
      const scope = root.closest('.shopify-section') || document;
      const anchor = scope.querySelector('.product-details h1');
      if (anchor) {
        root.dataset.gmInit = 'true';
        anchor.insertAdjacentElement('beforebegin', root);
        root.hidden = false;
        return;
      }
      if (attempt < 15) {
        setTimeout(() => initMaterialBadges(root, attempt + 1), 200);
      } else {
        console.warn('[gm-badges] Titre H1 introuvable — pastilles affichées à leur position d\u2019origine.');
        root.dataset.gmInit = 'true';
        root.hidden = false;
      }
    };

    const styleTrustBar = (attempt = 0) => {
      // Scoped to .product-information: the cart drawer can render its own
      // #trust-bar (same id) via the same .ultimate-badges anchor — see the
      // stylesheet comment above for why this must not match that one too.
      const iframe = document.querySelector('.product-information #trust-bar');
      if (!iframe) {
        if (attempt < 15) setTimeout(() => styleTrustBar(attempt + 1), 200);
        return;
      }
      iframe.style.transformOrigin = 'top center';
      iframe.style.transform = 'scale(0.85)';
    };

    // ✅ CORRECTIF (20/08) : cette fonction traitait à tort le champ caché
    // "pb-quantity-0" injecté par PandaBundle (id="offers-list-container-0" /
    // input hidden name="quantity") comme un vrai sélecteur de quantité natif,
    // à cause du sélecteur `input[name="quantity"]` qui matchait ce champ
    // caché en premier — c'est ce qui faisait échouer le repositionnement du
    // widget de livraison (il se rattachait au mauvais élément, tout en fin de
    // formulaire) et pouvait aussi fausser l'affichage/masquage du divider.
    // Deux corrections : on ignore désormais les inputs cachés, et on
    // n'accepte le conteneur PandaBundle que s'il contient réellement des
    // lignes rendues (l'app embed peut injecter un conteneur vide même quand
    // aucun bundle n'est configuré pour ce produit).
    const findQuantitySelector = (container) => {
      const native = container.querySelector(
        'quantity-selector, .quantity-selector, [data-quantity-selector], input[name="quantity"]:not([type="hidden"])'
      );
      if (native) return native;
      const bundle = container.querySelector('[id^="offers-list-container"]');
      return bundle && bundle.children.length > 0 ? bundle : null;
    };

    // ✅ CORRECTIF (20/08) : le widget de livraison est désormais ancré
    // directement sur le vrai bouton "Ajouter au panier" (via findRealButton,
    // déjà utilisé plus haut pour la barre flottante) plutôt que sur "ce qui
    // ressemble à un sélecteur de quantité" — c'est ce qui garantit l'ordre
    // demandé : PandaBundle (s'il existe) → widget de livraison → bouton,
    // quel que soit l'état de détection de findQuantitySelector ailleurs.
    const repositionDeliveryWidget = (attempt = 0) => {
      const container = document.querySelector('.buy-buttons-block');
      const widget = container && container.querySelector('delivery-preview-widget');
      const button = container && findRealButton(container);
      if (!widget || !button) {
        if (attempt < 15) setTimeout(() => repositionDeliveryWidget(attempt + 1), 200);
        else console.warn('[gm-delivery-position] Widget de livraison ou bouton introuvable — position inchangée.');
        return;
      }
      const place = () => {
        if (widget.nextElementSibling !== button) {
          button.insertAdjacentElement('beforebegin', widget);
        }
      };
      place();
      // PandaBundle peut injecter/remplacer son sélecteur après ce premier
      // passage — on revérifie plusieurs fois plutôt qu'une seule fois.
      [400, 900, 1600, 2600, 3600].forEach((delay) => setTimeout(place, delay));
    };

    const toggleDivider = (attempt = 0) => {
      const container = document.querySelector('.buy-buttons-block');
      const scope = document.querySelector('.product-details');
      if (!container || !scope) {
        if (attempt < 15) setTimeout(() => toggleDivider(attempt + 1), 200);
        return;
      }
      const divider = scope.querySelector('.divider');
      if (!divider) return;
      const check = () => {
        divider.style.display = findQuantitySelector(container) ? 'none' : '';
      };
      check();
      [400, 900, 1600, 2600].forEach((delay) => setTimeout(check, delay));
    };

    // ✅ AJOUT (20/08) : équilibre l'écart entre le bloc prix et la zone
    // boutons (sélecteur de quantité/bundle, widget de livraison, ajout au
    // panier) — sans PandaBundle, l'écart natif laissait une bande vide très
    // visible juste au-dessus du bouton ; avec PandaBundle, cette même bande
    // sert à séparer visuellement le sélecteur d'offres du reste. Les deux
    // valeurs sont volontairement figées en JS plutôt que laissées au
    // réglage natif, pour un rendu identique dans les deux cas.
    const BALANCE_GAP_WITH_PICKER = 20;
    const BALANCE_GAP_WITHOUT_PICKER = 10;
    const gmBalanceProductSpacing = (attempt = 0) => {
      const details = document.querySelector('.product-details');
      const container = document.querySelector('.buy-buttons-block');
      if (!details || !container) {
        if (attempt < 15) setTimeout(() => gmBalanceProductSpacing(attempt + 1), 200);
        return;
      }
      const apply = () => {
        const hasPicker = !!findQuantitySelector(container);
        details.style.setProperty(
          'gap',
          (hasPicker ? BALANCE_GAP_WITH_PICKER : BALANCE_GAP_WITHOUT_PICKER) + 'px',
          'important'
        );
      };
      apply();
      [400, 900, 1600, 2600, 3600].forEach((delay) => setTimeout(apply, delay));
    };

    const boot = () => {
      console.log('[gm-custom] boot() declenche');
      document.querySelectorAll('[data-gm-sticky-atc]').forEach(initStickyAtc);
      document.querySelectorAll('[data-gm-desc-tabs]').forEach(initDescTabs);
      document.querySelectorAll('[data-gm-badges]').forEach(initMaterialBadges);
      repositionDeliveryWidget();
      styleTrustBar();
      toggleDivider();
      gmBalanceProductSpacing();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
